import { render, staticRenderFns } from "./SchoolClassSchedule.vue?vue&type=template&id=56737618&scoped=true&"
import script from "./SchoolClassSchedule.vue?vue&type=script&lang=js&"
export * from "./SchoolClassSchedule.vue?vue&type=script&lang=js&"
import style0 from "./SchoolClassSchedule.vue?vue&type=style&index=0&id=56737618&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56737618",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
